<template lang="pug">
//- https://jasonwatmore.com/post/2019/08/21/vue-js-simple-pagination-example
.pagination-special
  ul.pagination-new(v-if='pager.pages && pager.pages.length' :style='ulStyles')
    li.page-item.page-number(v-for='page in pager.pages' :key='page' :style='liStyles')
      a(@click='setPage(page)' :class="{'active': pager.currentPage === page, 'pointer': pager.currentPage != page}" :style='aStyles') {{page}}

</template>

<script>
import paginate from 'jw-paginate';

export default {
  props: {
      // items: {
      //     type: Array,
      //     required: true
      // },
      totalRows: {
        type: Number,
        default: 1
      },
      initialPage: {
          type: Number,
          default: 1
      },
      pageSize: {
          type: Number,
          default: 10
      },
      maxPages: {
          type: Number,
          default: 8
      },
      // labels: {
      //     type: Object,
      //     default: () => defaultLabels
      // },
      styles: {
          type: Object
      },
      // disableDefaultStyles: {
      //     type: Boolean,
      //     default: false
      // }
  },
  data () {
      return {
          pager: {},
          ulStyles: {},
          liStyles: {},
          aStyles: {}
      }
  },
  created () {
      // if (!this.$listeners.changePage) {
      //     throw 'Missing required event listener: "changePage"';
      // }

      // set default styles unless disabled
      // if (!this.disableDefaultStyles) {
      //     this.ulStyles = defaultStyles.ul;
      //     this.liStyles = defaultStyles.li;
      //     this.aStyles = defaultStyles.a;
      // }

      // merge custom styles with default styles
      if (this.styles) {
          this.ulStyles = { ...this.ulStyles, ...this.styles.ul };
          this.liStyles = { ...this.liStyles, ...this.styles.li };
          this.aStyles = { ...this.aStyles, ...this.styles.a };
      }

      // set page if items array isn't empty
      try {
        this.setPage(this.initialPage);
      } catch(err) {
        // console.log('err')
      }
      
      // if (this.items && this.items.length) {
      //     this.setPage(this.initialPage);
      // }
  },
  methods: {
      setPage(page) {
          // const { items, pageSize, maxPages } = this;
          const { totalRows, pageSize, maxPages } = this;

          // get new pager object for specified page
          // const pager = paginate(items.length, page, pageSize, maxPages);
          const pager = paginate(totalRows, page, pageSize, maxPages);

          // get new page of items from items array
          // const pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

          // update pager
          this.pager = pager;

          // emit change page event to parent component
          // this.$emit('changePage', pageOfItems);
          this.$emit('pagechanged', page);
      }
  }
}
</script>